import a from "./_baseFor.js";
import e from "./keys.js";
var s = a, n = e;
function t(r, o) {
  return r && s(r, o, n);
}
var F = t;
export {
  F as default
};
//# sourceMappingURL=_baseForOwn.js.map
